import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./payroll.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Payroll Services</h3>
                </header>
                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>Effortless Payroll Management for Your Business</h3>
                        <p>
                            At <b>Serene Tax</b>, we understand that payroll
                            management can be time-consuming and complex. Our
                            comprehensive payroll services are designed to save
                            you time, ensure compliance, and provide accurate
                            and timely payroll processing. Let us handle the
                            intricacies of payroll so you can focus on running
                            and growing your business.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>{" "}
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>Why Choose Serene Tax for Payroll Services?</h3>
                        <p>
                            <b>Accurate Payroll Processing:</b> Avoid costly
                            errors with our meticulous attention to detail.
                        </p>
                        <p>
                            <b>Compliance Guaranteed:</b> Stay on top of tax
                            regulations, labor laws, and filing requirements.
                        </p>
                        <p>
                            <b>Time-Saving:</b> : Free up your resources by
                            outsourcing payroll to our experienced team.
                        </p>
                        <p>
                            <b>Tailored Solutions:</b> Our services are
                            customized to fit your business size, structure, and
                            needs.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Our Payroll Services Include:</h3>
                        <p>
                            <b>1.Payroll Processing:</b>We handle all aspects of
                            payroll, including calculating wages, overtime,
                            bonuses, and deductions, ensuring employees are paid
                            accurately and on time.
                        </p>
                        <p>
                            <b>2.Tax Withholding and Filing:</b>
                            Our team ensures correct tax withholding for
                            federal, state, and local taxes and manages timely
                            filing to avoid penalties.
                        </p>
                        <p>
                            <b>3.Direct Deposit Setup:</b>
                            Offer your employees the convenience of direct
                            deposit with our seamless setup and management.
                        </p>
                        <p>
                            <b>4.Employee Benefits Integration:</b>We manage
                            deductions for employee benefits, such as retirement
                            plans, health insurance, and more, ensuring accurate
                            record-keeping.
                        </p>
                        <p>
                            <b>5.Payroll Reports:</b>Receive detailed payroll
                            reports, including summaries of wages, tax
                            liabilities, and benefits, providing full
                            transparency and insight.
                        </p>
                        <p>
                            <b>6.W-2 and 1099 Preparation:</b>
                            At year-end, we prepare and distribute W-2s for
                            employees and 1099s for contractors, ensuring
                            compliance with IRS requirements.
                        </p>
                        <p>
                            <b>7.State and Federal Compliance:</b> We monitor
                            changes in labor laws and tax regulations to ensure
                            your payroll processes remain compliant.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Benefits of Professional Payroll Services</h3>
                        <p>
                            <b>Reduce Administrative Burden:</b>
                            Spend less time managing payroll and more time
                            growing your business.
                        </p>
                        <p>
                            <b>Ensure Accuracy:</b>
                            Avoid errors that could lead to employee
                            dissatisfaction or penalties.
                        </p>
                        <p>
                            <b>Stay Compliant:</b>
                            Keep up with ever-changing tax and labor regulations
                            with ease.
                        </p>
                        <p>
                            <b>Secure and Confidential:</b>
                            Protect sensitive employee information with our
                            secure payroll systems.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Industries We Serve</h3>
                        <h4>
                            Our bookkeeping services cater to a wide range of
                            industries, including:
                        </h4>
                        <ul>
                            <li>Small and Medium Businesses</li>
                            <li>Startups</li>
                            <li>Retail and Hospitality</li>
                            <li>Healthcare</li>
                            <li>Professional Services</li>
                            <li>Nonprofits</li>
                        </ul>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Our Process</h3>
                        <p>
                            <b>1.Initial Consultation :</b>
                            <br />
                            We assess your business’s payroll needs and
                            determine the best solutions for your organization.
                        </p>
                        <p>
                            <b>2.Setup or Transition</b>
                            <br />
                            Whether starting fresh or transitioning from another
                            provider, we handle the setup seamlessly, ensuring
                            accuracy and continuity.
                        </p>
                        <p>
                            <b>3.Ongoing Payroll Management:</b>
                            <br />
                            We manage payroll processing on your preferred
                            schedule (weekly, bi-weekly, or monthly), ensuring
                            timely payments.
                        </p>
                        <p>
                            <b>Regular Reporting and Communication:</b>
                            <br />
                            Receive detailed payroll reports and have direct
                            access to our team for any questions or concerns.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Why Serene Tax?</h3>
                        <p>
                            <b>Expertise You Can Trust:</b> Our team has years
                            of experience in payroll management and compliance.
                        </p>
                        <p>
                            <b>Customized Solutions: </b>We tailor our services
                            to fit the unique needs of your business.
                        </p>
                        <p>
                            <b>Affordable Pricing:</b>
                            Our payroll services are competitively priced with
                            no hidden fees.
                        </p>
                        <p>
                            <b>Client-Centered Approach: </b>: We prioritize
                            your business’s success and work closely with you
                            every step of the way.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1fr" }}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Simplify Your Payroll Today!</h3>
                        <p>
                            Take the stress out of payroll management with
                            <b>Serene Tax</b>. Let us handle the details while
                            you focus on what matters most—growing your
                            business.
                            <br />
                            Contact us today for a consultation.{" "}
                            <b>Call [+1 (262) 735-8874/ +1 (262) 735- 8875]</b>
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
